const static_lang = [
  {
    id: 0,
    short: 'en',
    long: 'English',
    dir: 'ltr',
  },
  // {
  //   id: 1,
  //   short: 'ur',
  //   long: 'Urdu',
  //   dir: 'rtl',
  // },
  // {
  //   id: 2,
  //   short: 'ar',
  //   long: 'Arabic',
  //   dir: 'rtl',
  // },
]

export default {
  data() {
    return {
      baseLangs: static_lang,
      langs: static_lang,
    }
  },
  computed: {
    isUrdu() {
      const lang = JSON.parse(localStorage.curLanguage).short
      let returnVal = false
      if (lang == 'ur') {
        returnVal = true
      }
      return returnVal
    },
  },
  methods: {
    selectLang(lang) {
      document.getElementsByTagName('body')[0].setAttribute('dir', lang.dir)
    },
    saveLanguageToLocalStorage(selectedLanguage) {
      window.localStorage.setItem('curLanguage', JSON.stringify(selectedLanguage))
    },
  },
}
